import { FC } from 'react';
import styles from './AppProgress.module.scss';
import clsx from 'clsx';

export type AppProgressProps = {
  value: number;
  max?: number;
  className?: string;
  color?: string;
};

export const AppProgress: FC<AppProgressProps> = ({ value, max = 100, className, color }) => {
  return (
    <progress
      className={clsx(styles.progress, className)}
      value={value}
      max={max}
      // @ts-ignore
      style={color ? { '--progress-color': color } : {}}
    />
  );
};
